define('models/user',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'users/' + this.id + '/' ) :
                ( App.Config.apiBase + 'users/' );
        },

        defaults: function () {
            return {
                id: null,
                first_name: '',
                last_name: '',
                username: '',
                user_details: {},
                role_object: {}
            };
        }
    });
});
